import React from 'react';
import { Appearance } from '@stripe/stripe-js';

export const appearance: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#5C534C',
    colorText: '#5C534C',
  },
};
